import { render, staticRenderFns } from "./ZTabsContent.vue?vue&type=template&id=0b931d0e&scoped=true&"
import script from "./ZTabsContent.vue?vue&type=script&lang=js&"
export * from "./ZTabsContent.vue?vue&type=script&lang=js&"
import style0 from "./ZTabsContent.vue?vue&type=style&index=0&id=0b931d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b931d0e",
  null
  
)

component.options.__file = "ZTabsContent.vue"
export default component.exports